import types from './actionTypes'

export default {
  openModal: name => ({name, type: types.OPEN_MODAL}),
  closeModal: name => ({name, type: types.CLOSE_MODAL}),
  openModalMulti: name => ({name, type: types.OPEN_MODAL_MULTI}),
  closeModalMulti: name => ({name, type: types.CLOSE_MODAL_MULTI})
}
